import { Component, OnInit } from '@angular/core';
import { DevicesService } from 'src/app/_services/devices.service';
import { FirebaseAuthService } from 'src/app/_services/firebase-auth.service';
import { User } from '../../../models/user';

@Component({
  selector: 'app-referred',
  templateUrl: './referred.component.html',
  styleUrls: ['./referred.component.scss']
})
export class ReferredComponent implements OnInit {

  diviceXs: boolean;
  diviceSm: boolean;

  referredPeople:any[] = [];
  referredUsers: User[] = [];

  constructor(public firebaseAuthService: FirebaseAuthService, private devicesService: DevicesService) {

    this.referredPeople = [
      {
        _id:"001",
        name: "Jonathan Henao",
        email:"jonathaa.hena@gmail.com",
        photo:"../../../../assets/img/profilePhoto/chucho.jpg"
      },
      {
        _id:"002",
        name: "John Terry",
        email:"jterry@gmail.com",
        photo:""
      },
      {
        _id:"003",
        name: "Ana Velez Ossa",
        email:"avelezossa@gmail.com",
        photo:"../../../../assets/img/profilePhoto/ana.jpg"
      }
    ]

  }

  ngOnInit(): void {
    this.referredUsers = this.firebaseAuthService.privateProfile.referredUsers;

    this.devicesService.dievice$.subscribe(res => {
      console.log("device", res)
      this.diviceXs = res === 'xs' ? true : false;
      this.diviceSm = res === 'sm' ? true : false;
    });
  }
}
